import { Link } from 'react-router-dom';

interface ArticleCardProps {
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  summary: string;
  image: string;
  publishedAt: string;
  readCount: number;
  tags: string[];
}

export default function ArticleCard({
  title,
  slug,
  category,
  categorySlug,
  summary,
  image,
  publishedAt,
  readCount,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block cursor-pointer">
        <div className="relative overflow-hidden aspect-[16/9]">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${categorySlug}`}
              className="inline-block px-2.5 py-1 text-xs rounded-full bg-primary-500/90 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {category}
            </Link>
          </div>
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 leading-snug">
            {title}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {summary}
        </p>
        <div className="mt-3 flex items-center justify-between">
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {publishedAt}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {readCount >= 10000 ? `${(readCount / 10000).toFixed(1)}万` : readCount}
            </span>
          </div>
          <div className="flex items-center gap-1.5 flex-wrap justify-end">
            {tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-1.5 py-0.5 text-xs rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}